const PricingInformation = () => {
  return (
    <div className={"w-full"}>
      <h1
        className={
          "text-center text-title1 font-[600] lg:text-left lg:text-heading2 lg:font-[800]"
        }
      >
        Winging 요금제
      </h1>
      <div
        className={
          "mt-[22px] break-words text-center text-title2 font-[700] text-gray-400 lg:mt-[0] lg:text-left"
        }
      >
        적합한 요금제를 통해 당신만의 AI 에이전트 Winging을 만나보세요.
      </div>
      <div
        className={
          "mt-[22px] text-center text-body1 font-[500] leading-[26px] text-gray-400 lg:mt-0 lg:text-left lg:text-title2"
        }
      >
        첫 달은 55,000 크레딧이 제공되어 Starter 요금제 선택 시 결제가 발생하지
        않습니다. <br />
        다음 결제일부터 선택하신 요금제에 따른 요금이 청구됩니다.
        <br />
        <span
          className={
            "mt-[22px] inline-block text-center text-label1 font-[400] lg:mt-0 lg:text-left lg:text-body1 lg:font-[500]"
          }
        >
          Winging 요금 결제는 선불 방식으로 진행됩니다{" "}
          <span className={"text-label1 lg:text-caption2"}>
            (단, 유료 기능 추가시 추가 청구 진행).
          </span>
        </span>
      </div>
    </div>
  );
};

export default PricingInformation;
